import client from './client';

export const authApi = {
  // Get current authenticated user
  async getMe() {
    const { data } = await client.get('/auth/me');
    return data;
  },

  // Logout
  async logout() {
    const { data } = await client.post('/auth/logout');
    return data;
  },

  // GitHub OAuth URL - redirect browser directly
  getGitHubAuthUrl() {
    return '/auth/github';
  },

  // Impersonate a user (root only)
  async impersonate(userId) {
    const { data } = await client.post(`/auth/impersonate/${userId}`);
    return data;
  },

  // Stop impersonating
  async stopImpersonating() {
    const { data } = await client.post('/auth/stop-impersonating');
    return data;
  },

  // Dev-only login picker. Returns null when the backend hasn't enabled it
  // (404), so the Login view can hide the panel without surfacing an error.
  async getDevUsers() {
    try {
      const { data } = await client.get('/auth/dev/users');
      return data;
    } catch (err) {
      if (err.response?.status === 404) {
        return null;
      }
      throw err;
    }
  },

  async devLogin(userId) {
    const { data } = await client.post('/auth/dev/login', { userId });
    return data;
  },
};
